import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {DeactivateGuardedComponent} from '../interfaces/DeactivateGuardedComponent';

@Injectable({
  providedIn: 'root'
})
export class DeactivateGuardService implements CanDeactivate<any> {

  constructor() {
  }

  canDeactivate(component: DeactivateGuardedComponent,
                route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot,
                nextState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return component.canExit();
  }
}
